import React, { useContext, useState } from "react";
import { FiHeart, FiPlus } from "react-icons/fi";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { formatPrice } from "../config/siteConfig";
import "../css/ui.scss";

const ProductCard = ({ product }) => {
  const { addCart, toggleWishlist, wishlist } = useContext(CartContext);
  const [imageError, setImageError] = useState(false);
  const isSaved = wishlist.includes(product.id);

  return (
    <article className="product-card">
      <div className="product-card__media">
        <Link
          to={`/shopDetails/${product.id}`}
          aria-label={`View ${product.name}`}
        >
          {!imageError ? (
            <img
              src={product.image}
              alt={product.name}
              loading="lazy"
              onError={() => setImageError(true)}
            />
          ) : (
            <span className="image-fallback" aria-label="Image unavailable">
              <span>Image coming soon</span>
            </span>
          )}
        </Link>
        <div className="product-card__badges" aria-label="Product labels">
          {product.compareAtPrice && <span className="badge badge--sale">Sale</span>}
          {product.newArrival && <span className="badge">New</span>}
        </div>
        <button
          className={`product-card__wish ${isSaved ? "is-active" : ""}`}
          type="button"
          onClick={() => toggleWishlist(product.id)}
          aria-label={isSaved ? "Remove from favourites" : "Add to favourites"}
          aria-pressed={isSaved}
        >
          <FiHeart aria-hidden="true" />
        </button>
      </div>

      <div className="product-card__body">
        <div className="product-card__eyebrow">
          <span>{product.subcategory}</span>
          <span>{product.attributes.origin}</span>
        </div>
        <h3>
          <Link to={`/shopDetails/${product.id}`}>{product.name}</Link>
        </h3>
        <div className="product-card__price-row">
          <div className="product-card__price">
            {product.compareAtPrice && (
              <del>{formatPrice(product.compareAtPrice)}</del>
            )}
            <span>{formatPrice(product.price)}</span>
            <small>/ {product.unit}</small>
          </div>
          <button
            type="button"
            className="quick-add"
            onClick={() => addCart(product.id, 1, product.unit)}
            aria-label={`Add ${product.name} to cart`}
          >
            <FiPlus aria-hidden="true" />
            <span>Add</span>
          </button>
        </div>
        <p className="product-card__date">Best before: {product.bestBefore}</p>
      </div>
    </article>
  );
};

export default ProductCard;
